import { Link } from 'react-router-dom-v5-compat';

import Banner from 'dashboard/components-lib/Banner';
import { EnvironmentStatus } from 'dashboard/models/environment';
import { Paragraph } from 'design-system/components/Text';
import useCurrentEnvironmentStatus from 'lib/hooks/useCurrentEnvironmentStatus';

const InactiveEnvironmentBanner = () => {
  const environmentStatus = useCurrentEnvironmentStatus();

  if (environmentStatus == null) {
    return (
      <Banner centered>
        <Paragraph color='primary'>
          Your user&apos;s roles do not have any active environments. Please reach out to your admin
          for access to environments.
        </Paragraph>
      </Banner>
    );
  } else if (environmentStatus !== EnvironmentStatus.Active) {
    return (
      <Banner centered>
        <Paragraph color='primary'>
          Your current environment is not active, so available actions will be limited. Please{' '}
          <Link to='/dashboard/contact-us'>contact us</Link> if you would like to upgrade.
        </Paragraph>
      </Banner>
    );
  } else {
    return null;
  }
};

export default InactiveEnvironmentBanner;
